<template>
    <div class="fluid">
        <h1 class="app-title">CADASTRO DE TERMO DE REGULARIZAÇÃO PARA PARCELAMENTO - TRP</h1>
        <b-card>
            <b-row class="d-flex justify-content-between">
                <b-col>
                    <CompBotaoExibirOcultarColuna
                            :fields="fields"
                            :showColunms="showColunms"
                            @toggleColuna="toggleColuna"/>
                </b-col>
                <b-col style="display: flex; justify-content: center;">
                    <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                                  :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;"
                                  v-if="configTable.perPage != 'Todos'">
                    </b-pagination>
                </b-col>
                <b-col>
                    <b-form-select v-model="configTable.perPage" :options="[10, 100, 500, 1000, 'Todos']" size="sm"
                                   class="mb-3 col-2" style="float:right"></b-form-select>
                    <b-button class="ml-2" variant="secondary" @click="limparFiltros"
                              style="float: right; margin-right: 10px; height: 32px; padding: 0 0.75rem;">
                        <i class="fas fa-broom"></i> Limpar Filtros
                    </b-button>
                </b-col>
            </b-row>
            <TabelaTipoTrp
                    :resultado="items"
                    :fields="fields"
                    :configTable="configTable"
                    :selecteds="selecteds"
                    :filtro="filtros"
                    @openFilterPopup="openFilterPopup"
                    @consultar="consultar"/>
            <b-row class="d-flex justify-content-between" style="margin-top: 10px;">
                <b-col>
                </b-col>
                <b-col style="display: flex; justify-content: center;">
                    <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                                  :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;"
                                  v-if="configTable.perPage != 'Todos'">
                    </b-pagination>
                </b-col>
                <b-col>
                    <div class="registros-encontrados">
                        <span>TRP(s) Encontradas:</span>
                    </div>
                    <div class="registros-encontrados-valor">
                        <span>{{configTable.perPage != 'Todos' ? configTable.rows : items.length}}</span>
                    </div>

                    <div class="registros-encontrados" style="margin-left: 15px">
                        <span>TRP(s) Selecionadas:</span>
                    </div>
                    <div class="registros-encontrados-valor">
                        <span>{{selecteds.length}}</span>
                    </div>
                </b-col>
            </b-row>
            <hr>
            <b-row>
                <b-col md="3"></b-col>
                <b-col md="6">
                    <div class="d-flex justify-content-between align-items-center">
                        <div style="margin: auto">
                            <b-button class="ml-2" variant="primary" @click="incluir">
                                <i class="fa fa-plus"></i> Incluir
                            </b-button>
                            <b-button class="ml-2" variant="secondary" @click="alterar" :disabled="selecteds.length !== 1">
                                <i class="fas fa-edit"></i> Editar
                            </b-button>
                            <b-button class="ml-2" variant="warning" @click="exibir" style="color: #FFF"
                                      :disabled="selecteds.length !== 1">
                                <i class="fas fa-eye"></i> Exibir
                            </b-button>
                        </div>
                    </div>
                </b-col>
                <b-col md="3"></b-col>
            </b-row>
        </b-card>
        <CompFiltroGrid
                ref="compFiltro"
                :filtro="filtro"
                @filtrarResultados="filtrarResultados"
                @ordenarResultados="ordenarResultados"/>
    </div>
</template>
<script>
    import Multiselect from 'vue-multiselect'
    import axios from 'axios'
    import TabelaTipoTrp from "./TabelaTipoTrp";
    import CompBotaoExibirOcultarColuna from "../shared/components/CompBotaoExibirOcultarColuna";
    import CompFiltroGrid from "../shared/components/CompFiltroGrid";
    import formatarMixins from '../../mixins/formatarMixins';

    export default {
        components: {CompFiltroGrid, CompBotaoExibirOcultarColuna, TabelaTipoTrp, Multiselect},
        mixins: [ formatarMixins ],
        data() {
            return {
                urlApi: null,
                token: null,
                value: null,
                options: [
                    {name: 'ICMS', code: 'av'},
                    {name: 'ITCMD', code: 'pa'}
                ],
                indice: null,
                fields: [
                    {
                        key: "selecionar",
                    }
                ],
                items: [],
                configTable: {
                    perPage: 10,
                    lastPage: null,
                    sortField: 'tipoTrp.descricao',
                    sortOrder: 'asc',
                    currentPage: 1,
                    rows: 0,
                    checkedAll: false,
                    load: false,
                },
                showColunms: [],
                selecteds: [],
                filtro: {
                    tipo: null,
                    campoFiltro: null,
                    filtrarEm: null,
                    mascara: null,
                    campoTexto: null,
                    campoMascara: null,
                    campoData: null,
                    campoRadio: null,
                    campoCheckbox: null,
                    listaValores: []
                },
                filtros: {
                    nome: null,
                    filtrarNome: null,
                    situacao: null,
                    refis: null,
                    tipoCredito: null,
                    filtrarTipoCredito: null,
                    prazoValidade: null,
                    exigeRequisicao: null,
                    exigeDesistencia: null,
                    exigeCustas: null,
                    exigeGarantia: null,
                    valorMinimo: null,
                    filtrarValorMinimo: null,
                }
            }
        },
        methods: {
            async consultar() {
                let perPageStr = `&perPage=${this.configTable.perPage}`;
                if (this.configTable.perPage === 'Todos') {
                    perPageStr = '';
                    this.configTable.currentPage = 1;
                    this.configTable.rows = 0;
                }

                this.configTable.load = true;
                axios.post(`${this.urlApi}/v1/tipoTrp/consultar?page=${this.configTable.currentPage}${perPageStr}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, this.filtros, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.items = response.data.resultado;
                    if (this.configTable.perPage !== 'Todos') {
                        this.configTable.rows = response.data.rows;
                        this.configTable.lastPage = Math.ceil(this.configTable.rows / this.configTable.perPage);
                    } else {
                        this.configTable.lastPage = 1;
                    }
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.configTable.load = false;
                })
            },

            prevPage() {
                this.configTable.currentPage = this.configTable.currentPage - 1;
                this.consultar();
            },

            nextPage() {
                this.configTable.currentPage = this.configTable.currentPage + 1;
                this.consultar();
            },

            async obterColunasUsuario() {
                const funcionalidade = 'tipoTrp';

                this.configTable.load = true;
                axios.get(`${this.urlApi}/v1/funcionalidade/configuracao/${funcionalidade}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    response.data.forEach((field, i) => {
                        if (field.ativo) {
                            this.showColunms.push(i + 1)
                        }
                        this.fields.push({
                            key: `${i + 1}`,
                            label: `${field.descricao}`,
                            thClass: field.ativo ? '' : 'd-none', tdClass: field.ativo ? '' : 'd-none',
                            codColunaFuncionalidade: field.codColunaFuncionalidade,
                            codFuncionalidade: field.codFuncionalidade
                        })
                    })
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.configTable.load = false;
                })
            },

            toggleColuna(i) {
                let ativo;
                if (this.showColunms.includes(i)) {
                    this.showColunms.splice(this.showColunms.indexOf(i), 1);
                    this.fields[i].thClass = 'd-none';
                    this.fields[i].tdClass = 'd-none';
                    ativo = false
                } else {
                    this.showColunms.push(i);
                    this.fields[i].thClass = '';
                    this.fields[i].tdClass = '';
                    ativo = true
                }

                this.atualizarConfiguracaoColunm(i, ativo)
            },

            async atualizarConfiguracaoColunm(i, ativo) {
                const json = {
                    codFuncionalidade: this.fields[i].codFuncionalidade,
                    codColunaFuncionalidade: this.fields[i].codColunaFuncionalidade,
                    ativo,
                };
                axios.put(`${this.urlApi}/v1/funcionalidade/configuracao`, json, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).catch((error) => {
                    this.exibirErro(error)
                })
            },

            incluir(evt) {
                evt.preventDefault();
                this.$router.push({path: '/tipo-trp/incluir'});
            },

            alterar(evt) {
                evt.preventDefault();
                if (this.selecteds[0]) {
                    this.$store.commit('setTipoTrp', this.selecteds[0]);
                    this.$router.push({path: '/tipo-trp/editar'});
                }
            },

            exibir(evt) {
                evt.preventDefault();
                if (this.selecteds[0]) {
                    this.$store.commit('setTipoTrp', this.selecteds[0]);
                    this.$router.push({path: '/tipo-trp/exibir'});
                }
            },

            openFilterPopup(campo, tipo, values, mascara, event) {
                if(document.getElementById('popup').style.display == 'block'
                    && this.filtro.campoFiltro == campo) {
                    this.$refs.compFiltro.closeFilterPopup();
                } else {
                    this.filtro.tipo = tipo;
                    this.filtro.campoFiltro = campo;
                    this.filtro.mascara = mascara;

                    if(this.filtro.campoFiltro == 'Nome') {
                        this.filtro.filtrarEm = this.filtros.filtrarNome;
                        this.filtro.campoTexto = this.filtros.nome;
                    } else if(this.filtro.campoFiltro == 'Situação') {
                        this.filtro.campoRadio = this.filtros.situacao;
                    } else if(this.filtro.campoFiltro == 'REFIS') {
                        this.filtro.campoRadio = this.filtros.refis;
                    } else if(this.filtro.campoFiltro == 'Tipos de Crédito') {
                        this.filtro.filtrarEm = this.filtros.filtrarTipoCredito;
                        this.filtro.campoTexto = this.filtros.tipoCredito;
                    } else if(this.filtro.campoFiltro == 'Prazo de Validade do TRP') {
                        this.filtro.campoMascara = this.filtros.prazoValidade;
                    } else if(this.filtro.campoFiltro == 'Exige Requisição') {
                        this.filtro.campoRadio = this.filtros.exigeRequisicao;
                    } else if(this.filtro.campoFiltro == 'Exige desistência') {
                        this.filtro.campoRadio = this.filtros.exigeDesistencia;
                    } else if(this.filtro.campoFiltro == 'Exige custas') {
                        this.filtro.campoRadio = this.filtros.exigeCustas;
                    } else if(this.filtro.campoFiltro == 'Exige garantia') {
                        this.filtro.campoRadio = this.filtros.exigeGarantia;
                    } else if(this.filtro.campoFiltro == 'Valor Mínimo') {
                        this.filtro.filtrarEm = this.filtros.filtrarValorMinimo;
                        this.filtro.campoTexto = this.filtros.valorMinimo;
                    }

                    if(this.filtro.tipo == "checkbox") {
                        this.filtro.listaValores = values;
                    } else if(values != null && values != "") {
                        this.filtro.listaValores = values.split(',');
                    }

                    this.$refs.compFiltro.openCloseFilterPopup(event);
                }
            },
            filtrarResultados(limpar) {
                if(limpar) {
                    this.filtro.filtrarEm = null;
                    this.filtro.campoTexto = null;
                    this.filtro.campoData = null;
                    this.filtro.campoRadio = null;
                    this.filtro.campoMascara = null;
                }

                if(this.filtro.campoFiltro == 'Nome') {
                    this.filtros.filtrarNome = this.filtro.filtrarEm;
                    this.filtros.nome = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Situação') {
                    this.filtros.situacao = this.filtro.campoRadio;
                } else if(this.filtro.campoFiltro == 'REFIS') {
                    this.filtros.refis = this.filtro.campoRadio;
                } else if(this.filtro.campoFiltro == 'Tipos de Crédito') {
                    this.filtros.filtrarTipoCredito = this.filtro.filtrarEm;
                    this.filtros.tipoCredito = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Prazo de Validade do TRP') {
                    this.filtros.prazoValidade = this.filtro.campoMascara;
                } else if(this.filtro.campoFiltro == 'Exige Requisição') {
                    this.filtros.exigeRequisicao = this.filtro.campoRadio;
                } else if(this.filtro.campoFiltro == 'Exige desistência') {
                    this.filtros.exigeDesistencia = this.filtro.campoRadio;
                } else if(this.filtro.campoFiltro == 'Exige custas') {
                    this.filtros.exigeCustas = this.filtro.campoRadio;
                } else if(this.filtro.campoFiltro == 'Exige garantia') {
                    this.filtros.exigeGarantia = this.filtro.campoRadio;
                } else if(this.filtro.campoFiltro == 'Valor Mínimo') {
                    this.filtros.filtrarValorMinimo = this.filtro.filtrarEm;
                    this.filtros.valorMinimo = this.filtro.campoTexto;
                }

                this.configTable.currentPage = 1;

                this.consultar();
            },
            ordenarResultados(order) {
                if(this.filtro.campoFiltro == 'Nome') {
                    this.configTable.sortField = 'tipoTrp.descricao';
                } else if(this.filtro.campoFiltro == 'Situação') {
                    this.configTable.sortField = 'tipoTrp.indativo';
                } else if(this.filtro.campoFiltro == 'REFIS') {
                    this.configTable.sortField = 'tipoTrp.indrefis';
                } else if(this.filtro.campoFiltro == 'Tipos de Crédito') {
                    this.configTable.sortField = 'tipoCredito';
                } else if(this.filtro.campoFiltro == 'Prazo de Validade do TRP') {
                    this.configTable.sortField = 'tipoTrp.numerodiasvalidade';
                } else if(this.filtro.campoFiltro == 'Exige Requisição') {
                    this.configTable.sortField = 'tipoTrp.indexigerequisicao';
                } else if(this.filtro.campoFiltro == 'Exige desistência') {
                    this.configTable.sortField = 'tipoTrp.indexigedesistencia';
                } else if(this.filtro.campoFiltro == 'Exige custas') {
                    this.configTable.sortField = 'tipoTrp.indexigepagamentocustas';
                } else if(this.filtro.campoFiltro == 'Exige garantia') {
                    this.configTable.sortField = 'tipoTrp.indexigegarantia';
                } else if(this.filtro.campoFiltro == 'Valor Mínimo') {
                    this.configTable.sortField = 'tipoTrp.valorgarantia';
                }

                this.configTable.sortOrder = order;

                this.consultar();
            },

            limparFiltros() {
                this.filtros = {
                    nome: null,
                    filtrarNome: null,
                    situacao: null,
                    refis: null,
                    tipoCredito: null,
                    filtrarTipoCredito: null,
                    prazoValidade: null,
                    exigeRequisicao: null,
                    exigeDesistencia: null,
                    exigeCustas: null,
                    exigeGarantia: null,
                    valorMinimo: null,
                    filtrarValorMinimo: null,
                };

                this.consultar();
            }
        },
        watch: {
            perPage() {
                this.configTable.currentPage = 1;
                this.consultar();
            }
        },
        computed: {
            perPage() {
                return this.configTable.perPage;
            },
        },
        mounted() {
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;

            this.$store.commit("setMessages", {});

            const msgCrud = this.$store.getters.getMsgCrud;
            if(msgCrud) {
                this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: [{message: msgCrud}]});
                this.$store.commit("setMsgCrud", null)
            }

            this.obterColunasUsuario();
            this.consultar();
        }
    }
</script>
